import initialState from './initialState'
import {
    SHOPPING_LIST_CREATE_LIST,
    SHOPPING_LIST_CREATE_ITEM,
    SHOPPING_LIST_DELETE_ITEM,
    SHOPPING_LIST_EDIT_ITEM
} from 'components/Items/constants/actionTypes'
import {
    FETCH_SEND_EMAIL_SHOPPING_LIST_REQUEST,
    FETCH_SEND_EMAIL_SHOPPING_LIST_SUCCESS,
    FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR,
    SET_EMAIL_ADDRESS
} from '../constants/actionTypes'


export default (state = initialState, action) => {
    switch (action.type) {
        case SET_EMAIL_ADDRESS:
            return {
                ...state,
                emailAddress: action.email,
                status: 'initial',
                errorMessage: initialState.errorMessage
            }

        case FETCH_SEND_EMAIL_SHOPPING_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                status: 'loading'
            }

        case FETCH_SEND_EMAIL_SHOPPING_LIST_SUCCESS:
            return {
                ...state,
                emailAddress: initialState.emailAddress,
                isLoading: false,
                status: 'submitted',
                isSent: true
            }

        case FETCH_SEND_EMAIL_SHOPPING_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                status: 'error',
                errorMessage: action.errorMessage
            }

        case SHOPPING_LIST_CREATE_ITEM:
        case SHOPPING_LIST_DELETE_ITEM:
        case SHOPPING_LIST_EDIT_ITEM:
        case SHOPPING_LIST_CREATE_LIST:
            return {
                ...state,
                isSent: false
            }

        default:
            return state
    }
}
